// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1 {
  margin: unset;
}

ion-header {
  box-shadow: none;
}

.category-block {
  background: #ffffff;
}

ion-content {
  background: transparent !important;
  --background: transparent !important;
}

ion-icon.brand-logo {
  width: 140px;
  height: 18px;
}

.main {
  overflow: auto;
}

.item-responsive {
  width: 100%;
}
@media (min-width: 991px) {
  .item-responsive {
    width: calc(33.333% - 10px);
    margin: 0 5px 10px;
  }
}

ion-searchbar {
  padding-inline-end: 25px;
  padding-inline-start: 25px;
  --placeholder-color: var(--ion-color-tertiary);
  --placeholder-opacity: 1;
  --color: var(--ion-color-tertiary);
  --icon-color: var(--ion-color-tertiary);
  --border-radius: 3px;
  --border: 1px solid var(--ion-color-tertiary);
  --background: #ffffff;
}
@media (min-width: 991px) {
  ion-searchbar {
    width: auto;
  }
}

.menu-heading {
  padding-top: 10px;
  background: #e7f0f1;
  padding-bottom: 10px;
}
@media (min-width: 991px) {
  .menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7f0f1;
  }
}

.list-title {
  margin-bottom: 15px;
}

.orders {
  overflow: auto;
  flex: 1;
  padding-bottom: 10px;
}

.items-wrap h3 {
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: bolder;
}
.items-wrap:last-of-type {
  padding-bottom: 400px;
}
.items-wrap .category-wrap {
  margin-bottom: 22px;
  padding: 7px;
}
.items-wrap .articles-wrapper {
  padding-inline: 16px;
}
@media (min-width: 991px) {
  .items-wrap .articles-wrapper {
    margin: 0 -16px;
  }
}

.main-row {
  height: 100%;
  overflow: hidden;
}

app-order-content {
  display: block;
  height: 100%;
}

.order-col {
  min-width: 380px;
}

.category-header {
  height: 80px;
  width: 100%;
  position: relative;
}
.category-header .category-headr-img {
  height: 80px;
  width: 100%;
  object-fit: cover;
  opacity: 0.7;
  z-index: 0.6;
}
.category-header h3 {
  position: absolute;
  z-index: 10;
  top: 50%;
  color: var(--ion-color-primary);
  left: 25px;
  transform: translateY(-50%);
}
@media (min-width: 991px) {
  .category-header {
    margin-top: 20px;
  }
}

.category-info {
  padding-left: 16px;
  height: 77px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  background: #f5f5f5;
}
.category-info .category-name {
  width: 100%;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
  z-index: 9999;
  font-family: AppFontBold;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  color: var(--color-white);
}
.category-info .category-description {
  z-index: 1;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  color: var(--color-white);
  margin-top: 7px;
}
.category-info .category-bg {
  object-fit: cover;
  right: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  position: absolute;
}
.category-info .category-logo {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 70px;
  height: auto;
  z-index: 2;
  pointer-events: none;
}

.header-wrap {
  padding-left: 11px;
}

.padding-end {
  padding-right: 11px;
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  backdrop-filter: blur(4px);
  background: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);
}
@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}

.category-list {
  display: flex;
  align-items: center;
  transition: 1s linear;
  opacity: 1;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  height: 72px;
  padding-inline: 16px;
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list .category {
  flex: 0 0 auto;
}
.category-list .category:first-child {
  margin-left: 15px;
}
.category-list .category:last-child {
  margin-right: 15px;
}

.menu-heading {
  padding-top: 10px;
  background: #6b5f4c;
  padding-bottom: 10px;
}
@media (min-width: 991px) {
  .menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7f0f1;
  }
}

.search-block {
  height: 55px;
  display: flex;
  align-items: center;
  opacity: 1;
  transition: 1s linear;
}

.hidden {
  opacity: 0;
  display: none;
  transition: 1s linear;
}

.main-row {
  height: 100%;
  overflow: hidden;
}

ion-chip {
  --icon-color: var(--ion-color-primary);
  height: 39px;
  background: #ffffff;
  border: 1px solid var(--ion-color-primary);
  transition: 200ms linear;
  min-width: 39px;
  flex-direction: column;
  padding: 0 12px !important;
  border-radius: var(--radius-default);
  justify-content: center;
}
ion-chip ion-label {
  font-size: 14px;
  margin: 0;
  color: var(--color-black);
  font-family: AppFont, sans-serif;
}
ion-chip.selected {
  transition: 200ms linear;
  background: var(--ion-color-primary);
}
ion-chip.selected ion-label {
  color: var(--color-white);
}
ion-chip .icon {
  height: 17px;
  width: 17px;
  margin: 0;
}

.service-not-available-container {
  width: 100%;
  --padding-start: 20px !important;
  --padding-end: 10px;
  --padding-top: 10px;
  --padding-bottom: 10px;
}
.service-not-available-container ion-icon {
  color: #fff !important;
}

.banner-row {
  height: 48px;
  overflow: hidden;
  transition: transform 1s ease-in-out, height 1s ease-in-out;
}
@media (max-width: 992px) {
  .banner-row {
    height: 60px;
  }
}
.banner-row.hide {
  height: 0;
  transform: rotateX(45deg) translate(0, -150%);
}

.allergen-banner {
  height: 100%;
  background: #656564;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px !important;
  padding-right: 16px;
}
.allergen-banner ion-icon {
  fill: #ffffff;
  margin-right: 15px;
  height: 27px;
  width: 32px;
}
.allergen-banner .info {
  width: 100%;
  margin: 0;
  padding-block: 5px;
  font-family: AppFont !important;
  font-size: 10px !important;
  line-height: 13.2px !important;
  color: #ffffff !important;
  text-wrap: balance;
}
.allergen-banner a {
  font-family: AppFont;
  font-size: 10px;
  color: var(--ion-color-secondary);
  text-decoration: underline;
}

.expand-block {
  position: fixed;
  height: 100vh;
  width: 100vw;
  right: -100%;
  top: 0;
  background: rgba(0, 0, 0, 0.1019607843);
  z-index: 10;
}
@media (max-width: 992px) {
  .expand-block {
    display: none;
  }
}
.expand-block.show {
  right: 0%;
}

.sidebar {
  position: absolute;
  right: -100%;
  top: 0;
  width: 35vw;
  height: 100vh;
  background: #fff;
  z-index: 11;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease-in-out;
}
@media (max-width: 992px) {
  .sidebar {
    display: none;
  }
}
.sidebar.show {
  right: 0%;
}

app-order-content {
  display: block;
  height: 100%;
  background: #f2f2f2;
}

.fixed-notification {
  pointer-events: none;
  position: fixed;
  bottom: 84px;
  left: 50%;
  transform: translateX(-50%);
  height: 68px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(30, 30, 28, 0.5803921569);
  backdrop-filter: blur(4px);
  z-index: 9999;
  opacity: 0;
  transition: 0.3s ease;
}
@media (min-width: 991px) {
  .fixed-notification {
    bottom: 0px;
  }
}
.fixed-notification::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -12px;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 12px solid rgba(30, 30, 28, 0.5803921569);
  backdrop-filter: blur(4px);
}
.fixed-notification ::ng-deep.inner-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fff;
  padding: 0 10px;
}
.fixed-notification ::ng-deep.inner-text span {
  font-family: AppFont;
  color: #fff;
}

.placeholder-item {
  height: 200px;
}

.fixed-notification.show-item {
  opacity: 1;
}

.tag-wrapper-wrapper {
  width: 100%;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  margin-top: -12px;
}
@media (max-width: 992px) {
  .tag-wrapper-wrapper {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
.tag-wrapper-wrapper::-webkit-scrollbar {
  display: none;
}
.tag-wrapper-wrapper .tag-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 0 auto;
  padding: 5px 10px;
  margin-bottom: 15px;
}
.tag-wrapper-wrapper .tag-wrapper .tag-block {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: center;
  height: 39px;
  background: #ffffff;
  border: 1px solid var(--ion-color-primary);
  transition: 200ms linear;
  min-width: 39px;
  width: max-content;
  padding: 0 12px !important;
  border-radius: var(--radius-default);
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  margin: 0;
  color: var(--color-black);
}
.tag-wrapper-wrapper .tag-wrapper .tag-block.selected {
  transition: 200ms linear;
  background: var(--ion-color-primary);
  color: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;;EAEC,aAAA;AAAD;;AAGA;EACC,gBAAA;AAAD;;AAGA;EACC,mBAAA;AAAD;;AAEA;EACC,kCAAA;EACA,oCAAA;AACD;;AACA;EACC,YAAA;EACA,YAAA;AAED;;AACA;EACC,cAAA;AAED;;AACA;EACC,WAAA;AAED;AC5BE;EDyBF;IAGE,2BAAA;IACA,kBAAA;EAIA;AACF;;AADA;EACC,wBAAA;EACA,0BAAA;EACA,8CAAA;EACA,wBAAA;EACA,kCAAA;EACA,uCAAA;EACA,oBAAA;EACA,6CAAA;EACA,qBAAA;AAID;AC9CE;EDiCF;IAWE,WAAA;EAMA;AACF;;AAJA;EACC,iBAAA;EACA,mBAAA;EACA,oBAAA;AAOD;ACzDE;ED+CF;IAKE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,gCAAA;EASA;AACF;;AANA;EACC,mBAAA;AASD;;AANA;EACC,cAAA;EACA,OAAA;EACA,oBAAA;AASD;;AALC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;AAQF;AADC;EACC,qBAAA;AAGF;AAAC;EACC,mBAAA;EACA,YAAA;AAEF;AACC;EACC,oBAAA;AACF;AC3FE;EDyFD;IAGE,eAAA;EAGD;AACF;;AACA;EACC,YAAA;EACA,gBAAA;AAED;;AACA;EACC,cAAA;EACA,YAAA;AAED;;AACA;EACC,gBAAA;AAED;;AAAA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAGD;AAFC;EACC,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AAIF;AAFC;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,+BAAA;EACA,UAAA;EACA,2BAAA;AAIF;ACnIE;ED8GF;IAoBE,gBAAA;EAKA;AACF;;AAHA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAMD;AAJC;EACC,WAAA;EAEA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,yBAAA;AAGF;AAAC;EACC,UAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AAEF;AACC;EACC,iBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;AAEC;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;AAAF;;AAIA;EACC,kBAAA;AADD;;AAGA;EACC,mBAAA;AAAD;;AAGA;EACC,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,0BAAA;EACA,4GAAA;AAAD;AClNE;ED2MF;IAUE,aAAA;EACA;AACF;;AACA;EACC,aAAA;EACA,mBAAA;EAEA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EAEA,YAAA;EACA,oBAAA;AAAD;AAEC;EACC,aAAA;AAAF;AAGC;EACC,cAAA;AADF;AAGE;EACC,iBAAA;AADH;AAIE;EACC,kBAAA;AAFH;;AAMA;EACC,iBAAA;EACA,mBAAA;EACA,oBAAA;AAHD;ACvPE;EDuPF;IAKE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,gCAAA;EADA;AACF;;AAOA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,UAAA;EACA,qBAAA;AALD;;AAOA;EACC,UAAA;EACA,aAAA;EACA,qBAAA;AAJD;;AAOA;EACC,YAAA;EACA,gBAAA;AAJD;;AAMA;EACC,sCAAA;EACA,YAAA;EAEA,mBAAA;EACA,0CAAA;EACA,wBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,oCAAA;EAGA,uBAAA;AAND;AAQC;EACC,eAAA;EACA,SAAA;EACA,yBAAA;EACA,gCAAA;AANF;AASC;EACC,wBAAA;EACA,oCAAA;AAPF;AASE;EACC,yBAAA;AAPH;AAWC;EACC,YAAA;EACA,WAAA;EACA,SAAA;AATF;;AAaA;EACC,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAVD;AAWC;EACC,sBAAA;AATF;;AAaA;EACC,YAAA;EACA,gBAAA;EACA,2DACC;AAXF;AC5TE;EDmUF;IAOE,YAAA;EAVA;AACF;AAYC;EACC,SAAA;EACA,6CAAA;AAVF;;AAcA;EACC,YAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mBAAA;AAZD;AAcC;EACC,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAZF;AAeC;EACC,WAAA;EACA,SAAA;EACA,kBAAA;EAEA,+BAAA;EACA,0BAAA;EACA,8BAAA;EAEA,yBAAA;EACA,kBAAA;AAfF;AAkBC;EACC,oBAAA;EACA,eAAA;EACA,iCAAA;EACA,0BAAA;AAhBF;;AAoBA;EACC,eAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,uCAAA;EAEA,WAAA;AAlBD;AC/WE;EDyXF;IAUE,aAAA;EAhBA;AACF;AAiBC;EACC,SAAA;AAfF;;AAmBA;EACC,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EAEA,aAAA;EACA,sBAAA;EAEA,kCAAA;AAlBD;ACpYE;ED0YF;IAcE,aAAA;EAhBA;AACF;AAiBC;EACC,SAAA;AAfF;;AAmBA;EACC,cAAA;EACA,YAAA;EACA,mBAAA;AAhBD;;AAmBA;EACC,oBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EAEA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,0CAAA;EACA,0BAAA;EAEA,aAAA;EACA,UAAA;EACA,qBAAA;AAnBD;AC1aE;ED2aF;IAoBE,WAAA;EAjBA;AACF;AAmBC;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,qDAAA;EACA,0BAAA;AAjBF;AAoBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAlBF;AAmBE;EACC,oBAAA;EACA,WAAA;AAjBH;;AAsBA;EACC,aAAA;AAnBD;;AAsBA;EACC,UAAA;AAnBD;;AAsBA;EACC,WAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AAnBD;ACndE;EDieF;IAQE,wBAAA;IACA,qBAAA;EAlBA;AACF;AAmBC;EACC,aAAA;AAjBF;AAoBC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAlBF;AAoBE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,oCAAA;EAEA,oCAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;AAnBH;AAqBG;EACC,wBAAA;EACA,oCAAA;EAEA,yBAAA;AApBJ","sourcesContent":["@use '../../../theme/mixins' as *;\np,\nh1 {\n\tmargin: unset;\n}\n\nion-header {\n\tbox-shadow: none;\n}\n\n.category-block {\n\tbackground: #ffffff;\n}\nion-content {\n\tbackground: transparent !important;\n\t--background: transparent !important;\n}\nion-icon.brand-logo {\n\twidth: 140px;\n\theight: 18px;\n}\n\n.main {\n\toverflow: auto;\n}\n\n.item-responsive {\n\twidth: 100%;\n\t@include desktop {\n\t\twidth: calc(33.333% - 10px);\n\t\tmargin: 0 5px 10px;\n\t}\n}\n\nion-searchbar {\n\tpadding-inline-end: 25px;\n\tpadding-inline-start: 25px;\n\t--placeholder-color: var(--ion-color-tertiary);\n\t--placeholder-opacity: 1;\n\t--color: var(--ion-color-tertiary);\n\t--icon-color: var(--ion-color-tertiary);\n\t--border-radius: 3px;\n\t--border: 1px solid var(--ion-color-tertiary);\n\t--background: #ffffff;\n\t@include desktop {\n\t\twidth: auto;\n\t}\n}\n.menu-heading {\n\tpadding-top: 10px;\n\tbackground: #e7f0f1;\n\tpadding-bottom: 10px;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #e7f0f1;\n\t}\n}\n\n.list-title {\n\tmargin-bottom: 15px;\n}\n\n.orders {\n\toverflow: auto;\n\tflex: 1;\n\tpadding-bottom: 10px;\n}\n\n.items-wrap {\n\th3 {\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 12px;\n\t\tfont-weight: bolder;\n\t}\n\n\t&:first-of-type {\n\t\t// padding-top: 12px;\n\t}\n\n\t&:last-of-type {\n\t\tpadding-bottom: 400px;\n\t}\n\n\t.category-wrap {\n\t\tmargin-bottom: 22px;\n\t\tpadding: 7px;\n\t}\n\n\t.articles-wrapper {\n\t\tpadding-inline: 16px;\n\t\t@include desktop {\n\t\t\tmargin: 0 -16px;\n\t\t}\n\t}\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n}\n\n.order-col {\n\tmin-width: 380px;\n}\n.category-header {\n\theight: 80px;\n\twidth: 100%;\n\tposition: relative;\n\t.category-headr-img {\n\t\theight: 80px;\n\t\twidth: 100%;\n\t\tobject-fit: cover;\n\t\topacity: 0.7;\n\t\tz-index: 0.6;\n\t}\n\th3 {\n\t\tposition: absolute;\n\t\tz-index: 10;\n\t\ttop: 50%;\n\t\tcolor: var(--ion-color-primary);\n\t\tleft: 25px;\n\t\ttransform: translateY(-50%);\n\t}\n\t@include desktop {\n\t\tmargin-top: 20px;\n\t}\n}\n.category-info {\n\tpadding-left: 16px;\n\theight: 77px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tposition: relative;\n\tbackground: #f5f5f5;\n\n\t.category-name {\n\t\twidth: 100%;\n\n\t\tword-break: break-word;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tmargin: 0px;\n\t\tz-index: 9999;\n\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 22px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0.02em;\n\t\ttext-transform: capitalize;\n\n\t\tcolor: var(--color-white);\n\t}\n\n\t.category-description {\n\t\tz-index: 1;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\tcolor: var(--color-white);\n\t\tmargin-top: 7px;\n\t}\n\n\t.category-bg {\n\t\tobject-fit: cover;\n\t\tright: 0px;\n\t\ttop: 0px;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t}\n\n\t.category-logo {\n\t\tposition: absolute;\n\t\tright: 12px;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\twidth: 70px;\n\t\theight: auto;\n\t\tz-index: 2;\n\t\tpointer-events: none;\n\t}\n}\n\n.header-wrap {\n\tpadding-left: 11px;\n}\n.padding-end {\n\tpadding-right: 11px;\n}\n\n.footer-btn {\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpadding: 16px;\n\tbackdrop-filter: blur(4px);\n\tbackground: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);\n\t// box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.25);\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n.category-list {\n\tdisplay: flex;\n\talign-items: center;\n\n\ttransition: 1s linear;\n\topacity: 1;\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none; /* Firefox */\n\n\theight: 72px;\n\tpadding-inline: 16px;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.category {\n\t\tflex: 0 0 auto;\n\n\t\t&:first-child {\n\t\t\tmargin-left: 15px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-right: 15px;\n\t\t}\n\t}\n}\n.menu-heading {\n\tpadding-top: 10px;\n\tbackground: #6b5f4c;\n\tpadding-bottom: 10px;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #e7f0f1;\n\t}\n}\n// .first {\n// \tmargin-top: 10px;\n// }\n\n.search-block {\n\theight: 55px;\n\tdisplay: flex;\n\talign-items: center;\n\n\topacity: 1;\n\ttransition: 1s linear;\n}\n.hidden {\n\topacity: 0;\n\tdisplay: none;\n\ttransition: 1s linear;\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\nion-chip {\n\t--icon-color: var(--ion-color-primary);\n\theight: 39px;\n\n\tbackground: #ffffff;\n\tborder: 1px solid var(--ion-color-primary);\n\ttransition: 200ms linear;\n\tmin-width: 39px;\n\tflex-direction: column;\n\tpadding: 0 12px !important;\n\tborder-radius: var(--radius-default);\n\t// text-transform: uppercase;\n\n\tjustify-content: center;\n\n\tion-label {\n\t\tfont-size: 14px;\n\t\tmargin: 0;\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFont, sans-serif;\n\t}\n\n\t&.selected {\n\t\ttransition: 200ms linear;\n\t\tbackground: var(--ion-color-primary);\n\n\t\tion-label {\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n\n\t.icon {\n\t\theight: 17px;\n\t\twidth: 17px;\n\t\tmargin: 0;\n\t}\n}\n\n.service-not-available-container {\n\twidth: 100%;\n\t--padding-start: 20px !important;\n\t--padding-end: 10px;\n\t--padding-top: 10px;\n\t--padding-bottom: 10px;\n\tion-icon {\n\t\tcolor: #fff !important;\n\t}\n}\n\n.banner-row {\n\theight: 48px;\n\toverflow: hidden;\n\ttransition:\n\t\ttransform 1s ease-in-out,\n\t\theight 1s ease-in-out;\n\t@include mobile {\n\t\theight: 60px;\n\t}\n\n\t&.hide {\n\t\theight: 0;\n\t\ttransform: rotateX(45deg) translate(0, -150%);\n\t}\n}\n\n.allergen-banner {\n\theight: 100%;\n\tbackground: #656564;\n\t// height: 39px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding-left: 16px !important;\n\tpadding-right: 16px;\n\n\tion-icon {\n\t\tfill: #ffffff;\n\t\tmargin-right: 15px;\n\t\theight: 27px;\n\t\twidth: 32px;\n\t}\n\n\t.info {\n\t\twidth: 100%;\n\t\tmargin: 0;\n\t\tpadding-block: 5px;\n\n\t\tfont-family: AppFont !important;\n\t\tfont-size: 10px !important;\n\t\tline-height: 13.2px !important;\n\n\t\tcolor: #ffffff !important;\n\t\ttext-wrap: balance;\n\t}\n\n\ta {\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tcolor: var(--ion-color-secondary);\n\t\ttext-decoration: underline;\n\t}\n}\n\n.expand-block {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100vw;\n\tright: -100%;\n\ttop: 0;\n\tbackground: #0000001a;\n\n\tz-index: 10;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\n.sidebar {\n\tposition: absolute;\n\tright: -100%;\n\ttop: 0;\n\twidth: 35vw;\n\theight: 100vh;\n\tbackground: #fff;\n\tz-index: 11;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\ttransition: right 0.3s ease-in-out;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n\tbackground: #f2f2f2;\n}\n\n.fixed-notification {\n\tpointer-events: none;\n\tposition: fixed;\n\tbottom: 84px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\n\theight: 68px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: #1e1e1c94;\n\tbackdrop-filter: blur(4px);\n\n\tz-index: 9999;\n\topacity: 0;\n\ttransition: 0.3s ease;\n\t@include desktop {\n\t\tbottom: 0px;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\tbottom: -12px;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-left: 14px solid transparent;\n\t\tborder-right: 14px solid transparent;\n\t\tborder-top: 12px solid #1e1e1c94;\n\t\tbackdrop-filter: blur(4px);\n\t}\n\n\t::ng-deep.inner-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\tcolor: #fff;\n\t\tpadding: 0 10px;\n\t\tspan {\n\t\t\tfont-family: AppFont;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n\n.placeholder-item {\n\theight: 200px;\n}\n\n.fixed-notification.show-item {\n\topacity: 1;\n}\n\n.tag-wrapper-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\tmargin-top: -12px;\n\n\t@include mobile {\n\t\t-ms-overflow-style: none;\n\t\tscrollbar-width: none;\n\t}\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.tag-wrapper {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 6px;\n\t\tmargin: 0 auto;\n\t\tpadding: 5px 10px;\n\t\tmargin-bottom: 15px;\n\n\t\t.tag-block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tjustify-content: center;\n\t\t\theight: 39px;\n\t\t\tbackground: #ffffff;\n\t\t\tborder: 1px solid var(--ion-color-primary);\n\t\t\ttransition: 200ms linear;\n\t\t\tmin-width: 39px;\n\t\t\twidth: max-content;\n\t\t\tpadding: 0 12px !important;\n\t\t\tborder-radius: var(--radius-default);\n\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tmargin: 0;\n\t\t\tcolor: var(--color-black);\n\n\t\t\t&.selected {\n\t\t\t\ttransition: 200ms linear;\n\t\t\t\tbackground: var(--ion-color-primary);\n\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
